import isPrototype from "./_isPrototype.js";
import nativeKeys from "./_nativeKeys.js";
var objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function baseKeys(object) {
  if (!isPrototype(object))
    return nativeKeys(object);
  var result = [];
  for (var key in Object(object))
    hasOwnProperty.call(object, key) && key != "constructor" && result.push(key);
  return result;
}
export {
  baseKeys as default
};
//# sourceMappingURL=_baseKeys.js.map
